module.exports = __webpack_public_path__ + "img/st-cb6-1-011.087fb601.gif";